import { toApiDate } from "@src/utils/dates";
import { DisclosureState } from "@src/utils/mobx/states/DisclosureState";
import { endOfMonth, startOfMonth, subMonths } from "date-fns";
import { FieldState } from "formstate";
import { action, computed, makeObservable } from "mobx";
import type { TimeBillingStore } from "../../store";

export class CreateModalStore {
  private parentStore: TimeBillingStore;

  readonly dateFrom = new FieldState<Date>(
    startOfMonth(subMonths(new Date(), 1)),
  );

  readonly dateTo = new FieldState<Date>(endOfMonth(subMonths(new Date(), 1)));

  readonly disclosureState = new DisclosureState({
    onClose: () => {
      this.dateFrom.reset();
      this.dateTo.reset();
    },
  });

  constructor(parentStore: TimeBillingStore) {
    makeObservable(this);
    this.parentStore = parentStore;
  }

  @computed
  get isOpen(): boolean {
    return this.disclosureState.isOpen;
  }

  @computed
  get isLoading(): boolean {
    return (
      this.parentStore.isCreateLoading || this.parentStore.isCreateDataLoading
    );
  }

  @action.bound
  async create(): Promise<void> {
    await this.parentStore.createAndEdit(
      toApiDate(this.dateFrom.value),
      toApiDate(this.dateTo.value),
    );
    this.disclosureState.onClose();
  }
}
